import React from "react";

import { useInView } from "react-intersection-observer";
import styles from "./MultiSelect.scss";

const ROOT_MARGIN = "200px 0px";

interface LazyListItemProps {
  children: React.ReactNode;
  height?: number;
}

export function LazyListItem({ children }: LazyListItemProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: ROOT_MARGIN,
  });

  if (!inView) {
    return <div ref={ref} className={styles["lazy-div-min-height"]} />;
  }

  return <>{children}</>;
}
